export default __webpack_public_path__ + "static/OpenSans-Bold-ff184fecf504bf1f0eec52f21964d4c0.woff2";